import { AdCampaignStatusesEnum } from '@shared/api/graphql/generated';

import { TEXTS } from '../texts';
import type { PromoStatus } from './types';

export const PROMO_DROPDOWN_GAP = 4;

export const PROMO_STATUS_OPTIONS: Array<{
  key: PromoStatus;
  label: string;
  status: AdCampaignStatusesEnum;
}> = [
  { key: 'active', label: TEXTS.AUDIO_REPORT_PROMOS_FILTER_ACTIVE, status: AdCampaignStatusesEnum.Active },
  { key: 'planned', label: TEXTS.AUDIO_REPORT_PROMOS_FILTER_PLANNED, status: AdCampaignStatusesEnum.Planned },
  { key: 'passed', label: TEXTS.AUDIO_REPORT_PROMOS_FILTER_PASSED, status: AdCampaignStatusesEnum.Passed },
  { key: 'stopped', label: TEXTS.AUDIO_REPORT_PROMOS_FILTER_STOPPED, status: AdCampaignStatusesEnum.Stopped },
];

export const PROMO_STATUS_TITLE_BY_STATUS: Record<PromoStatus, string> = {
  active: TEXTS.AUDIO_REPORT_PROMOS_STATUS_ACTIVE,
  passed: TEXTS.AUDIO_REPORT_PROMOS_STATUS_PASSED,
  planned: TEXTS.AUDIO_REPORT_PROMOS_STATUS_PLANNED,
  stopped: TEXTS.AUDIO_REPORT_PROMOS_STATUS_STOPPED,
};
